<template>
  <modal ref="modal">
    <template v-slot:header>
       <div class="text-center"><a class="text-blue-800" href="https://wovn.io/" target="_blank">Wovn.io</a></div>
    </template>
    <div><p class="text-center">Developed an automated, dynamic web translation system.</p>
      <br/>
    <div class="bg-gray-300 font-mono p-2">
    <p>- Used <a class="text-blue-500 hover:text-blue-800" href="https://www.ruby-lang.org/en/" target="_blank">Ruby</a> on <a class="text-blue-500 hover:text-blue-800" href="https://rubyonrails.org/" target="_blank">Rails</a> to build the backend, <a class="text-blue-500 hover:text-blue-800" href="https://vuejs.org/" target="_blank">Vue.js</a> as frontend and <a class="text-blue-500 hover:text-blue-800" href="https://www.oracle.com/database/technologies/appdev/sql-developer.html" target="_blank">SQL</a> for the database.</p>
    <p>- Built features utilizing <a class="text-blue-500 hover:text-blue-800" href="https://en.wikipedia.org/wiki/Levenshtein_distance" target="_blank">Levenshtein Distance Algorithm</a>.</p> <p>- Wrote file parsers to convert <a class="text-blue-500 hover:text-blue-800" href="https://en.wikipedia.org/wiki/XLIFF" target="_blank">XLIFF</a> and <a class="text-blue-500 hover:text-blue-800" href="https://developer.apple.com/library/archive/documentation/Cocoa/Conceptual/LoadingResources/Strings/Strings.html" target="_blank">STRINGS</a> files to/from CSV.</p></div>
    </div>
  </modal>
</template>
<script>
  import Modal from './Modal.vue'

  export default {
    components: {
      Modal
    },

    methods: {
      open () {
        this.$refs.modal.open()
      },
      close () {
        this.$refs.modal.close()
      }
    }
  }
</script>
<style>
  a {
    color:;
  }
</style>
